import { IUser } from "@/api";
import { Button } from "@/components/shared/buttons/Button";
import { useDialogs } from "@toolpad/core";
import EditUser from "../actions/EditUser";

interface IProps {
    user: IUser;
}

export const EditUserButton = ({ user }: IProps) => {
    const dialogs = useDialogs();

    const handleEdit = async () => {
        await dialogs.open(EditUser, {
            user,
        });
    };

    return (
        <Button
            variant="contained"
            color="secondary"
            sx={{ borderRadius: 29 }}
            disableElevation
            onClick={handleEdit}
        >
            Edit
        </Button>
    );
};
